module.exports = __webpack_public_path__ + "img/payTMS.a3e2d97d.png";